export default __webpack_public_path__ + "static/media/erreur-min.95203e77.jpg";